// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__238hM","Icons":"Footer_Icons__3PTSJ","IconContainer":"Footer_IconContainer__2erq5","FooterTitle":"Footer_FooterTitle__1Ygxr"};